import { FC } from "react";
import { useTranslation } from 'react-i18next';
import { Button as AntButton, Modal } from 'antd';

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  setTab: (tab: string) => void;
}

const CompleteTransfer1Modal: FC<IProps> = ({
  visible, setVisible, setTab
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      title={t('class.class.title9')}
      visible={visible}
      onCancel={() => {
        setVisible(false);
        setTab('register');        
      }}
      footer={[
        <div className='comm-btn__area justify-content-center'>	
          <AntButton
            key="primary"
            className='btn-basic pink'
            onClick={() => {
              setVisible(false);
              setTab('register');
            }}
          >
            {t('common.button.confirm')}
          </AntButton>
        </div>
      ]}
    >
      {t('class.class.text22')}
    </Modal>
  );
}

export default CompleteTransfer1Modal;
